import { ALL_RESULTS } from '@/features/bidding/constants'
import { useBiddingContext } from '@/features/bidding/contexts/BiddingContext'
import { useBidHistoriesPageQuery } from '@/features/bidding/hooks/useBidHistoriesPageQuery'
import type { GroupedBidParams } from '@/features/bidding/utils/groupedBidParams/buildBiddingLinks'

type Options = {
  enabled?: boolean
}

export function useBidOfferBidHistories(groupParams: GroupedBidParams, options?: Options) {
  const { selectedCountry } = useBiddingContext()

  const { bidHistoriesPage } = useBidHistoriesPageQuery(
    {
      pagination: { pageSize: ALL_RESULTS, page: 0 },
      sorting: [],
      filter: {
        items: [
          { field: 'portfolio', operator: 'equals', value: groupParams.portfolioCode },
          { field: 'marketProgram', operator: 'equals', value: groupParams.marketProgram },
          { field: 'deliveryDay', operator: 'equals', value: groupParams.deliveryDay },
          { field: 'bidType', operator: 'equals', value: groupParams.bidType },
        ],
      },
      countryFilter: selectedCountry,
    },
    { enabled: options?.enabled ?? true },
  )

  return {
    bidHistories: bidHistoriesPage?.bidHistories,
    isLoading: !bidHistoriesPage && (options?.enabled ?? true),
  }
}
